import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Assignment } from '../entity/assignment';

import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpAuthorizationHeader } from '../misc/httpauthorizationheader';
import { toAssignmentTypeTransformer } from '../state/transformers/todo.transformers';
import { AssignmentType } from '../state/types';
import { BLService } from './bl.service';

@Injectable({
  providedIn: 'root',
})
export class AssignmentService extends BLService {
  private options = new HttpAuthorizationHeader('application/json');
  private RESOURCE_ENDPOINT = 'assignment';

  constructor() {
    super();
    this.useCache();
  }

  private url = environment.serverUrlV2 + this.RESOURCE_ENDPOINT;

  getAssignments(): Observable<Assignment[]> {
    if (!this.hasCacheExpired()) {
      return this.getCacheObservable<Assignment[]>();
    }

    const headers = this.options.getAuthorizationHeader();
    return this.http.get<Assignment[]>(this.url, headers).pipe(
      tap((result) => this.updateCache(result)),
      this.catchErrorAndShowMessage(),
    );
  }

  getAssignmentTypes(): Observable<AssignmentType[]> {
    return this.getAssignments().pipe(map((assignments) => assignments.map(toAssignmentTypeTransformer.transform)));
  }
}
